import React, { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import { resetTrip } from "../features/tripSlice";

const Summary = () => {
  const { startPoint, endPoint, transportMode, summary, alternate } =
    useSelector((state) => state.trip);

  const dispatch = useDispatch();
  const navigate = useNavigate();
  useEffect(() => {
    if (summary === null) {
      navigate("/");
    }
  }, [summary, navigate]);

  if (summary === null) {
    // Optionally, you can return null or some fallback UI here
    return null; // or some loading spinner / placeholder
  }

  const formatCost = (cost) => {
    if (cost < 1000) {
      return cost; // Return the cost as is if it's less than 1000
    } else if (cost < 1_000_000) {
      return `${Math.ceil(cost / 1000)}k`; // Format cost in thousands
    } else {
      return `${Math.ceil(cost / 1_000_000)}M`; // Format cost in millions
    }
  };

  return (
    <div className="container">
      <div className="content">
        <div className="header-large">
          <h1 className="title">Trip Summary</h1>
        </div>

        <div className="divider mb-16 "></div>

        <section className="mb-16">
          <h3 className="title-4">Comparison</h3>
          <p className="text-sm">
            Here’s your total <b>carbon emission</b> and <b>cost</b> for this
            trip. You have saved & reduced carbon emissions nicely 👍 Good job!
            View the comparison below if you use private transportation.
          </p>
        </section>

        <div
          className={`card-summary ${
            summary.emission < alternate.emission ? "active" : ""
          }`}
        >
          <div className="icon-wrapper">
            {/* <img src="../img/transportation/grey/car.png" alt="Car icon" /> */}
            <img
              src={`../img/transportation/grey/${
                transportMode.is_public ? "train.png" : "car.png"
              }`}
              alt="Car icon"
            />
          </div>

          <div className="content-wrapper">
            <h4 className="summary-title">Current Transports</h4>

            <div className="info-item mb-3">
              <div className="item-label">
                <svg
                  width="16"
                  height="17"
                  viewBox="0 0 16 17"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <g clipPath="url(#clip0_14969_14701)">
                    <path
                      d="M8.41598 0.723223C8.37032 0.654744 8.30846 0.598596 8.23589 0.559762C8.16332 0.520929 8.08229 0.50061 7.99998 0.50061C7.91768 0.50061 7.83664 0.520929 7.76407 0.559762C7.69151 0.598596 7.62965 0.654744 7.58398 0.723223L4.58398 5.22322C4.53388 5.29852 4.50513 5.38599 4.50081 5.47633C4.49649 5.56667 4.51675 5.65649 4.55944 5.73622C4.60213 5.81596 4.66565 5.88262 4.74323 5.92911C4.82081 5.9756 4.90954 6.00018 4.99998 6.00022H5.09798L3.07598 9.23522C3.02868 9.31091 3.0025 9.39788 3.00015 9.4871C2.99781 9.57632 3.01939 9.66454 3.06266 9.74261C3.10593 9.82067 3.1693 9.88573 3.2462 9.93103C3.32311 9.97633 3.41073 10.0002 3.49998 10.0002H3.69098L2.05298 13.2762C2.01479 13.3525 1.99671 13.4372 2.00049 13.5224C2.00427 13.6075 2.02976 13.6903 2.07455 13.7629C2.11935 13.8354 2.18195 13.8953 2.25641 13.9369C2.33087 13.9784 2.41472 14.0002 2.49998 14.0002H6.99998V16.5002H8.99998V14.0002H13.5C13.5852 14.0002 13.6691 13.9784 13.7436 13.9369C13.818 13.8953 13.8806 13.8354 13.9254 13.7629C13.9702 13.6903 13.9957 13.6075 13.9995 13.5224C14.0033 13.4372 13.9852 13.3525 13.947 13.2762L12.31 10.0002H12.501C12.5902 10.0002 12.6779 9.97633 12.7548 9.93103C12.8317 9.88573 12.895 9.82067 12.9383 9.74261C12.9816 9.66454 13.0032 9.57632 13.0008 9.4871C12.9985 9.39788 12.9723 9.31091 12.925 9.23522L10.902 6.00022H11C11.0904 6.00018 11.1792 5.9756 11.2567 5.92911C11.3343 5.88262 11.3978 5.81596 11.4405 5.73622C11.4832 5.65649 11.5035 5.56667 11.4992 5.47633C11.4948 5.38599 11.4661 5.29852 11.416 5.22322L8.41598 0.723223ZM6.43698 5.25822C6.39379 5.18014 6.33049 5.11503 6.25365 5.06966C6.17681 5.02429 6.08922 5.00032 5.99998 5.00022H5.93398L7.99998 1.90122L10.066 5.00022H9.99998C9.91073 5.00022 9.82311 5.02411 9.7462 5.06941C9.6693 5.11472 9.60593 5.17977 9.56266 5.25784C9.51939 5.3359 9.49781 5.42413 9.50015 5.51335C9.5025 5.60257 9.52868 5.68954 9.57598 5.76522L11.598 9.00022H11.5C11.4147 9.00023 11.3309 9.02203 11.2564 9.06357C11.182 9.10511 11.1193 9.165 11.0746 9.23755C11.0298 9.3101 11.0043 9.3929 11.0005 9.47808C10.9967 9.56326 11.0148 9.64799 11.053 9.72422L12.69 13.0002H3.30898L4.94698 9.72422C4.98518 9.64799 5.00325 9.56326 4.99948 9.47808C4.9957 9.3929 4.97021 9.3101 4.92541 9.23755C4.88062 9.165 4.81802 9.10511 4.74356 9.06357C4.6691 9.02203 4.58525 9.00023 4.49998 9.00022H4.40198L6.42398 5.76522C6.47117 5.68955 6.49725 5.60264 6.49954 5.51349C6.50182 5.42435 6.48023 5.33621 6.43698 5.25822Z"
                      fill="currentColor"
                    />
                  </g>
                  <defs>
                    <clipPath id="clip0_14969_14701">
                      <rect
                        width="16"
                        height="16"
                        fill="currentColor"
                        transform="translate(0 0.5)"
                      />
                    </clipPath>
                  </defs>
                </svg>
                Total Carbon Emission
              </div>

              <div className="item-value">
                <h4>{summary.emission}</h4>
                <span className="unit">kg CO2</span>
              </div>
            </div>

            <div className="info-item">
              <div className="item-label">
                <svg
                  width="16"
                  height="17"
                  viewBox="0 0 16 17"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path
                    d="M1.33325 5.16659C1.33325 4.81296 1.47373 4.47382 1.72378 4.22378C1.97382 3.97373 2.31296 3.83325 2.66659 3.83325H13.3333C13.6869 3.83325 14.026 3.97373 14.2761 4.22378C14.5261 4.47382 14.6666 4.81296 14.6666 5.16659V11.8333C14.6666 12.1869 14.5261 12.526 14.2761 12.7761C14.026 13.0261 13.6869 13.1666 13.3333 13.1666H2.66659C2.31296 13.1666 1.97382 13.0261 1.72378 12.7761C1.47373 12.526 1.33325 12.1869 1.33325 11.8333V5.16659Z"
                    stroke="currenColor"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                  />
                  <path
                    d="M8 10.4999C9.10457 10.4999 10 9.60445 10 8.49988C10 7.39531 9.10457 6.49988 8 6.49988C6.89543 6.49988 6 7.39531 6 8.49988C6 9.60445 6.89543 10.4999 8 10.4999Z"
                    stroke="currenColor"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                  />
                  <path
                    d="M1.33325 6.49992C2.0405 6.49992 2.71877 6.21897 3.21887 5.71887C3.71897 5.21877 3.99992 4.5405 3.99992 3.83325M11.9999 13.1666C11.9999 12.4593 12.2809 11.7811 12.781 11.281C13.2811 10.7809 13.9593 10.4999 14.6666 10.4999"
                    stroke="currenColor"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                  />
                </svg>
                Total Spending
              </div>

              <div className="item-value">
                <h4>{formatCost(summary.cost)}</h4>
                {/* <h4>{summary.cost}</h4> */}
                <span className="unit">IDR</span>
              </div>
            </div>
          </div>
        </div>

        <div
          className={`card-summary ${
            alternate.emission < summary.emission ? "active" : ""
          }`}
        >
          <div className="icon-wrapper">
            <img
              src={`../img/transportation/grey/${
                alternate.is_public ? "train.png" : "car.png"
              }`}
              alt="Transport icon"
            />
          </div>

          <div className="content-wrapper">
            <h4 className="summary-title">If You Use {alternate.type}</h4>

            <div className="info-item mb-3">
              <div className="item-label">
                <svg
                  width="16"
                  height="17"
                  viewBox="0 0 16 17"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <g clipPath="url(#clip0_14969_14701)">
                    <path
                      d="M8.41598 0.723223C8.37032 0.654744 8.30846 0.598596 8.23589 0.559762C8.16332 0.520929 8.08229 0.50061 7.99998 0.50061C7.91768 0.50061 7.83664 0.520929 7.76407 0.559762C7.69151 0.598596 7.62965 0.654744 7.58398 0.723223L4.58398 5.22322C4.53388 5.29852 4.50513 5.38599 4.50081 5.47633C4.49649 5.56667 4.51675 5.65649 4.55944 5.73622C4.60213 5.81596 4.66565 5.88262 4.74323 5.92911C4.82081 5.9756 4.90954 6.00018 4.99998 6.00022H5.09798L3.07598 9.23522C3.02868 9.31091 3.0025 9.39788 3.00015 9.4871C2.99781 9.57632 3.01939 9.66454 3.06266 9.74261C3.10593 9.82067 3.1693 9.88573 3.2462 9.93103C3.32311 9.97633 3.41073 10.0002 3.49998 10.0002H3.69098L2.05298 13.2762C2.01479 13.3525 1.99671 13.4372 2.00049 13.5224C2.00427 13.6075 2.02976 13.6903 2.07455 13.7629C2.11935 13.8354 2.18195 13.8953 2.25641 13.9369C2.33087 13.9784 2.41472 14.0002 2.49998 14.0002H6.99998V16.5002H8.99998V14.0002H13.5C13.5852 14.0002 13.6691 13.9784 13.7436 13.9369C13.818 13.8953 13.8806 13.8354 13.9254 13.7629C13.9702 13.6903 13.9957 13.6075 13.9995 13.5224C14.0033 13.4372 13.9852 13.3525 13.947 13.2762L12.31 10.0002H12.501C12.5902 10.0002 12.6779 9.97633 12.7548 9.93103C12.8317 9.88573 12.895 9.82067 12.9383 9.74261C12.9816 9.66454 13.0032 9.57632 13.0008 9.4871C12.9985 9.39788 12.9723 9.31091 12.925 9.23522L10.902 6.00022H11C11.0904 6.00018 11.1792 5.9756 11.2567 5.92911C11.3343 5.88262 11.3978 5.81596 11.4405 5.73622C11.4832 5.65649 11.5035 5.56667 11.4992 5.47633C11.4948 5.38599 11.4661 5.29852 11.416 5.22322L8.41598 0.723223ZM6.43698 5.25822C6.39379 5.18014 6.33049 5.11503 6.25365 5.06966C6.17681 5.02429 6.08922 5.00032 5.99998 5.00022H5.93398L7.99998 1.90122L10.066 5.00022H9.99998C9.91073 5.00022 9.82311 5.02411 9.7462 5.06941C9.6693 5.11472 9.60593 5.17977 9.56266 5.25784C9.51939 5.3359 9.49781 5.42413 9.50015 5.51335C9.5025 5.60257 9.52868 5.68954 9.57598 5.76522L11.598 9.00022H11.5C11.4147 9.00023 11.3309 9.02203 11.2564 9.06357C11.182 9.10511 11.1193 9.165 11.0746 9.23755C11.0298 9.3101 11.0043 9.3929 11.0005 9.47808C10.9967 9.56326 11.0148 9.64799 11.053 9.72422L12.69 13.0002H3.30898L4.94698 9.72422C4.98518 9.64799 5.00325 9.56326 4.99948 9.47808C4.9957 9.3929 4.97021 9.3101 4.92541 9.23755C4.88062 9.165 4.81802 9.10511 4.74356 9.06357C4.6691 9.02203 4.58525 9.00023 4.49998 9.00022H4.40198L6.42398 5.76522C6.47117 5.68955 6.49725 5.60264 6.49954 5.51349C6.50182 5.42435 6.48023 5.33621 6.43698 5.25822Z"
                      fill="currentColor"
                    />
                  </g>
                  <defs>
                    <clipPath id="clip0_14969_14701">
                      <rect
                        width="16"
                        height="16"
                        fill="currentColor"
                        transform="translate(0 0.5)"
                      />
                    </clipPath>
                  </defs>
                </svg>
                Total Carbon Emission
              </div>

              <div className="item-value">
                <h4>{alternate.emission}</h4>
                <span className="unit">kg CO2</span>
              </div>
            </div>

            <div className="info-item">
              <div className="item-label">
                <svg
                  width="16"
                  height="17"
                  viewBox="0 0 16 17"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path
                    d="M1.33325 5.16659C1.33325 4.81296 1.47373 4.47382 1.72378 4.22378C1.97382 3.97373 2.31296 3.83325 2.66659 3.83325H13.3333C13.6869 3.83325 14.026 3.97373 14.2761 4.22378C14.5261 4.47382 14.6666 4.81296 14.6666 5.16659V11.8333C14.6666 12.1869 14.5261 12.526 14.2761 12.7761C14.026 13.0261 13.6869 13.1666 13.3333 13.1666H2.66659C2.31296 13.1666 1.97382 13.0261 1.72378 12.7761C1.47373 12.526 1.33325 12.1869 1.33325 11.8333V5.16659Z"
                    stroke="currenColor"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                  />
                  <path
                    d="M8 10.4999C9.10457 10.4999 10 9.60445 10 8.49988C10 7.39531 9.10457 6.49988 8 6.49988C6.89543 6.49988 6 7.39531 6 8.49988C6 9.60445 6.89543 10.4999 8 10.4999Z"
                    stroke="currenColor"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                  />
                  <path
                    d="M1.33325 6.49992C2.0405 6.49992 2.71877 6.21897 3.21887 5.71887C3.71897 5.21877 3.99992 4.5405 3.99992 3.83325M11.9999 13.1666C11.9999 12.4593 12.2809 11.7811 12.781 11.281C13.2811 10.7809 13.9593 10.4999 14.6666 10.4999"
                    stroke="currenColor"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                  />
                </svg>
                Total Spending
              </div>

              <div className="item-value">
                <h4>{formatCost(alternate.cost)}</h4>
                <span className="unit">IDR</span>
              </div>
            </div>
          </div>
        </div>

        <div className="divider my-4"></div>

        <section className="mb-16">
          <h3 className="title-4">Trip Detail</h3>

          <div className="trip-wrapper">
            <img
              src={transportMode.icon}
              alt={transportMode.type}
              className="trip-icon"
            />

            <ul className="timeline">
              <li className="timeline-item">
                <div className="timeline-icon">
                  <svg
                    width="16"
                    height="16"
                    viewBox="0 0 16 16"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <path
                      d="M14 6.66663C14 11.3333 8 15.3333 8 15.3333C8 15.3333 2 11.3333 2 6.66663C2 5.07533 2.63214 3.5492 3.75736 2.42399C4.88258 1.29877 6.4087 0.666626 8 0.666626C9.5913 0.666626 11.1174 1.29877 12.2426 2.42399C13.3679 3.5492 14 5.07533 14 6.66663Z"
                      fill="#CB5C5C"
                      stroke="#CB5C5C"
                      strokeLinecap="round"
                      strokeLinejoin="round"
                    />
                    <path
                      d="M8 8.66663C9.10457 8.66663 10 7.7712 10 6.66663C10 5.56206 9.10457 4.66663 8 4.66663C6.89543 4.66663 6 5.56206 6 6.66663C6 7.7712 6.89543 8.66663 8 8.66663Z"
                      stroke="white"
                      strokeLinecap="round"
                      strokeLinejoin="round"
                    />
                  </svg>
                </div>
                {startPoint.name}
              </li>

              <li className="timeline-item end">
                <div className="timeline-icon">
                  <svg
                    width="16"
                    height="16"
                    viewBox="0 0 16 16"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <path
                      d="M15 8.00004C15 11.6819 12.0152 14.6667 8.33329 14.6667C4.65139 14.6667 1.66663 11.6819 1.66663 8.00004C1.66663 4.31814 4.65139 1.33337 8.33329 1.33337C12.0152 1.33337 15 4.31814 15 8.00004Z"
                      fill="#1F8562"
                    />
                    <path
                      d="M12.9999 8.00004C12.9999 10.5774 10.9105 12.6667 8.33321 12.6667C5.75588 12.6667 3.66654 10.5774 3.66654 8.00004C3.66654 5.42271 5.75588 3.33337 8.33321 3.33337C10.9105 3.33337 12.9999 5.42271 12.9999 8.00004Z"
                      fill="#FAFAFA"
                    />
                    <path
                      d="M10.9999 8.00004C10.9999 9.4728 9.80597 10.6667 8.33321 10.6667C6.86045 10.6667 5.66654 9.4728 5.66654 8.00004C5.66654 6.52728 6.86045 5.33337 8.33321 5.33337C9.80597 5.33337 10.9999 6.52728 10.9999 8.00004Z"
                      fill="#1F8562"
                    />
                  </svg>
                </div>
                {endPoint.name}
              </li>
            </ul>
          </div>
        </section>

        <div className="sticky-button">
          <button
            className="btn btn-outline-success btn-outline-confirm w-100"
            onClick={() => {
              dispatch(resetTrip());
              navigate("/");
            }}
          >
            Try Different Route
          </button>
        </div>
      </div>
    </div>
  );
};

export default Summary;
